// src/modules/app-views/account/components/AccountProfileTitle.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { theme } from 'antd';
import { SubscriptionProfileIcon } from 'layouts/TopBar/SubscriptionSelector';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AccountProfileTitle = ({ profile, style = {} }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const profileLabel = getProfileLabel(profile);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div
      className="flex-row"
      style={{
        marginLeft: -1,
        marginBottom: '2px',
        color: token.colorTextSecondary,
        ...style,
      }}
    >
      <SubscriptionProfileIcon profile={profile} />
      &nbsp;&nbsp;
      {translateX(profileLabel)}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AccountProfileTitle;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getProfileLabel(profile) {
  switch (profile) {
    case 'owner':
      return 'owner';
    case 'keyUser':
      return 'key_user';
    case 'guest':
      return 'common_user';
    default:
      return profile;
  }
}
